import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import Tabs from "../../components/common/Tabs";
import { Button, Modal, Popover } from "antd";
import WorkFlow from "./runAworkFlowModal/WorkFlow";

function Tasks() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [visible, setVisible] = useState(false);

  const tabs = [
    {
      link: "/tasks/library",
      title: "Library",
    },
    {
      link: "/tasks/reports",
      title: "Reports",
    },
    {
      link: "/tasks/inbox",
      title: "Inbox",
    },
  ];

  const showModal = () => {
    setVisible(false);

    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
  };

  const runModal = (
    <span
      style={{ color: "#000", cursor: "pointer", padding: "15px" }}
      onClick={showModal}
    >
      {" "}
      <i className="fa-solid fa-play" style={{ marginRight: "10px" }}></i> Run a
      Workflow
    </span>
  );

  const handleVisibleChange = (visible) => {
    setVisible(visible);
  };

  return (
    <>
      <div className="tasksPagesContainer">
        <div>
          <Tabs
            tabs={tabs}
            keepFirstLinkActive={true}
            style={{ marginBottom: "0px!important" }}
          />
          <Popover
            content={runModal}
            trigger="click"
            visible={visible}
            onVisibleChange={handleVisibleChange}
            placement="bottomRight"
          >
            <Button type="primary" className="taskRunAWorkFlowBtn">
              + New
            </Button>
          </Popover>
        </div>
        <Outlet />
        <div className="RightSidebar"></div>

        <Modal
          open={isModalOpen}
          onCancel={handleCancel}
          footer={null}
          centered
        >
          <WorkFlow setIsModalOpen={setIsModalOpen} />
        </Modal>
      </div>
    </>
  );
}

export default Tasks;
